import React from 'react';

const Header = () => {
  return (
    <header>
      <div className="title">
        <h1>9o OUR OCEAN CONFERENCE</h1>
        <h3>The Athanasios C. Laskaridis Charitable Foundation is dedicated to the future of our seas and the sustainability of our planet!</h3>
      </div>
    </header>
  );
};

export default Header;
